<div class="space-y-8">
  <!-- Section 1 : Zones d'intervention géographiques -->
  @if (showMode() === 'all' || showMode() === 'zones') {
    <div
      class="p-6 sm:p-7 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-6"
    >
      <div
        class="flex items-start justify-between gap-4 pb-5 border-b border-neutral-3 dark:border-neutral-4"
      >
        <div class="flex items-start gap-3.5">
          <div
            class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0 mt-0.5"
          >
            <mat-icon class="w-5! h-5! text-xl!">map</mat-icon>
          </div>
          <div class="space-y-1">
            <h4 class="text-base sm:text-lg font-bold text-neutral-12">Vos zones d'intervention</h4>
            <p class="text-xs sm:text-sm text-neutral-10 dark:text-neutral-11 leading-relaxed max-w-xl">
              Définissez votre région principale et les départements que vous couvrez pour recevoir les
              opportunités de mandats.
            </p>
          </div>
        </div>

        <span
          class="text-xs font-bold px-3 py-1.5 rounded-xl border shrink-0 inline-flex items-center gap-2 shadow-xs"
          [class.bg-primary-2]="selectedDepartments().length > 0"
          [class.text-primary-11]="selectedDepartments().length > 0"
          [class.border-primary-4]="selectedDepartments().length > 0"
          [class.bg-neutral-2]="selectedDepartments().length === 0"
          [class.dark:bg-neutral-3]="selectedDepartments().length === 0"
          [class.text-neutral-10]="selectedDepartments().length === 0"
          [class.dark:text-neutral-11]="selectedDepartments().length === 0"
          [class.border-neutral-4]="selectedDepartments().length === 0"
          [class.dark:border-neutral-5]="selectedDepartments().length === 0"
        >
          <span
            class="w-2 h-2 rounded-full"
            [class.bg-primary-9]="selectedDepartments().length > 0"
            [class.bg-neutral-6]="selectedDepartments().length === 0"
          ></span>
          {{ selectedDepartments().length }} département{{ selectedDepartments().length > 1 ? 's' : '' }}
        </span>
      </div>

      <etxe-agent-zones-form
        [primaryRegion]="model().primaryRegion || undefined"
        [interventionZones]="model().interventionZones"
        (primaryRegionChange)="setPrimaryRegion($event)"
        (interventionZonesChange)="onInterventionZonesChange($event)"
      />
    </div>
  }

  <!-- Section 2 : Villes prioritaires pour les alertes email (Max 5 communes) -->
  @if (showMode() === 'all' || showMode() === 'cities') {
    <div
      class="p-6 sm:p-7 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-6"
    >
      <div
        class="flex items-start justify-between gap-4 pb-5 border-b border-neutral-3 dark:border-neutral-4"
      >
        <div class="flex items-start gap-3.5">
          <div
            class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0 mt-0.5"
          >
            <mat-icon class="w-5! h-5! text-xl!">notifications_active</mat-icon>
          </div>
          <div class="space-y-1">
            <div class="flex items-center gap-2">
              <h4 class="text-base sm:text-lg font-bold text-neutral-12">
                Villes prioritaires pour vos alertes
              </h4>
              <span
                class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11 border border-primary-4"
              >
                Optionnel
              </span>
            </div>
            <p class="text-xs sm:text-sm text-neutral-10 dark:text-neutral-11 leading-relaxed max-w-xl">
              Ciblez jusqu'à 5 communes favorites pour recevoir des notifications en temps réel dès qu'une
              opportunité correspondante est publiée.
            </p>
          </div>
        </div>

        <span
          class="text-xs font-bold px-3 py-1.5 rounded-xl border shrink-0 inline-flex items-center gap-1.5 shadow-xs"
          [class.bg-primary-2]="model().preferredCities.length > 0"
          [class.text-primary-11]="model().preferredCities.length > 0"
          [class.border-primary-4]="model().preferredCities.length > 0"
          [class.bg-neutral-2]="model().preferredCities.length === 0"
          [class.dark:bg-neutral-3]="model().preferredCities.length === 0"
          [class.text-neutral-10]="model().preferredCities.length === 0"
          [class.dark:text-neutral-11]="model().preferredCities.length === 0"
          [class.border-neutral-4]="model().preferredCities.length === 0"
          [class.dark:border-neutral-5]="model().preferredCities.length === 0"
        >
          <mat-icon class="w-3.5! h-3.5! text-sm!">location_city</mat-icon>
          {{ model().preferredCities.length }}/5
        </span>
      </div>

      <etxe-agent-cities-form
        [preferredCities]="model().preferredCities"
        [selectedDepartments]="selectedDepartments()"
        [selectedDepartmentsSummary]="selectedDepartmentsSummary()"
        (preferredCitiesChange)="onPreferredCitiesChange($event)"
      />
    </div>
  }

  <!-- Section 3 : Statut, Réseau ou Agence -->
  @if (showMode() === 'all' || showMode() === 'network') {
    <div
      class="p-6 sm:p-7 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-6"
    >
      <div class="flex items-start gap-3.5 pb-5 border-b border-neutral-3 dark:border-neutral-4">
        <div
          class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0 mt-0.5"
        >
          <mat-icon class="w-5! h-5! text-xl!">corporate_fare</mat-icon>
        </div>
        <div class="space-y-1">
          <h4 class="text-base sm:text-lg font-bold text-neutral-12">Réseau ou enseigne commerciale</h4>
          <p class="text-xs sm:text-sm text-neutral-10 dark:text-neutral-11 leading-relaxed max-w-xl">
            Indiquez le nom de votre réseau national de mandataires ou la marque commerciale de votre agence.
          </p>
        </div>
      </div>

      <etxe-agent-network-form
        [agentType]="agentType()"
        [network]="model().network"
        (networkChange)="onNetworkChange($event)"
      />
    </div>
  }

  <!-- Section 4 : Spécialités de transactions -->
  @if (showMode() === 'all' || showMode() === 'specialties') {
    <div
      class="p-6 sm:p-7 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-6"
    >
      <div
        class="flex items-start justify-between gap-4 pb-5 border-b border-neutral-3 dark:border-neutral-4"
      >
        <div class="flex items-start gap-3.5">
          <div
            class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0 mt-0.5"
          >
            <mat-icon class="w-5! h-5! text-xl!">category</mat-icon>
          </div>
          <div class="space-y-1">
            <h4 class="text-base sm:text-lg font-bold text-neutral-12">Spécialités de transactions</h4>
            <p class="text-xs sm:text-sm text-neutral-10 dark:text-neutral-11 leading-relaxed max-w-xl">
              Précisez vos domaines d'expertise typologique (résidentiel, prestige, commerces, etc.).
            </p>
          </div>
        </div>

        <span
          class="text-xs font-bold px-3 py-1.5 rounded-xl border shrink-0 inline-flex items-center gap-1.5 shadow-xs"
          [class.bg-primary-2]="model().specialties.length > 0"
          [class.text-primary-11]="model().specialties.length > 0"
          [class.border-primary-4]="model().specialties.length > 0"
          [class.bg-neutral-2]="model().specialties.length === 0"
          [class.dark:bg-neutral-3]="model().specialties.length === 0"
          [class.text-neutral-10]="model().specialties.length === 0"
          [class.dark:text-neutral-11]="model().specialties.length === 0"
          [class.border-neutral-4]="model().specialties.length === 0"
          [class.dark:border-neutral-5]="model().specialties.length === 0"
        >
          {{ model().specialties.length }} sélectionnée{{ model().specialties.length > 1 ? 's' : '' }}
        </span>
      </div>

      <etxe-agent-specialties-form
        [specialties]="model().specialties"
        (specialtiesChange)="onSpecialtiesChange($event)"
      />
    </div>
  }

  <!-- Section 5 : Présentation et biographie -->
  @if (showMode() === 'all' || showMode() === 'bio') {
    <div
      class="p-6 sm:p-7 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-6"
    >
      <div class="flex items-start gap-3.5 pb-5 border-b border-neutral-3 dark:border-neutral-4">
        <div
          class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0 mt-0.5"
        >
          <mat-icon class="w-5! h-5! text-xl!">feed</mat-icon>
        </div>
        <div class="space-y-1">
          <div class="flex items-center gap-2">
            <h4 class="text-base sm:text-lg font-bold text-neutral-12">Présentation et biographie</h4>
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11 border border-primary-4"
            >
              Recommandé
            </span>
          </div>
          <p class="text-xs sm:text-sm text-neutral-10 dark:text-neutral-11 leading-relaxed max-w-xl">
            Rédigez une brève présentation mettant en avant vos atouts, votre parcours et vos réussites pour
            rassurer les propriétaires vendeurs.
          </p>
        </div>
      </div>

      <etxe-agent-bio-form [bio]="model().bio" (bioChange)="onBioChange($event)" />
    </div>
  }

  <!-- Section 6 : Adresse de réception & Horaires de permanence -->
  @if (showMode() === 'all' || showMode() === 'officeHours') {
    <div
      class="p-6 sm:p-7 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-6"
    >
      <div class="flex items-start gap-3.5 pb-5 border-b border-neutral-3 dark:border-neutral-4">
        <div
          class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0 mt-0.5"
        >
          <mat-icon class="w-5! h-5! text-xl!">store</mat-icon>
        </div>
        <div class="space-y-1">
          <div class="flex items-center gap-2">
            <h4 class="text-base sm:text-lg font-bold text-neutral-12">Adresse professionnelle & Horaires</h4>
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11 border border-primary-4"
            >
              Visibilité clients
            </span>
          </div>
          <p class="text-xs sm:text-sm text-neutral-10 dark:text-neutral-11 leading-relaxed max-w-xl">
            Indiquez l'adresse de votre agence ou permanence et vos créneaux de disponibilité pour accueillir
            vos clients.
          </p>
        </div>
      </div>

      <etxe-agent-office-hours-form
        [officialAddress]="officialCardAddress()"
        [officeAddress]="model().officeAddress"
        [openingHours]="model().openingHours"
        [useCustomAddress]="useCustomAddress()"
        (officeAddressChange)="onOfficeAddressChange($event)"
        (openingHoursChange)="onOpeningHoursChange($event)"
        (useCustomAddressChange)="onUseCustomAddressChange($event)"
      />
    </div>
  }

  <!-- Section 7 : Réseaux sociaux & Liens de réputation web -->
  @if (showMode() === 'all' || showMode() === 'socialLinks') {
    <div
      class="p-6 sm:p-7 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-6"
    >
      <div class="flex items-start gap-3.5 pb-5 border-b border-neutral-3 dark:border-neutral-4">
        <div
          class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0 mt-0.5"
        >
          <mat-icon class="w-5! h-5! text-xl!">share</mat-icon>
        </div>
        <div class="space-y-1">
          <div class="flex items-center gap-2">
            <h4 class="text-base sm:text-lg font-bold text-neutral-12">Réseaux professionnels & Liens web</h4>
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11 border border-primary-4"
            >
              Optionnel
            </span>
          </div>
          <p class="text-xs sm:text-sm text-neutral-10 dark:text-neutral-11 leading-relaxed max-w-xl">
            Renseignez votre site web, votre fiche Google Avis, vos attestations certifiées (Immodvisor) et
            vos réseaux pros.
          </p>
        </div>
      </div>

      <etxe-agent-social-links-form
        [links]="model().socialLinks"
        (linksChange)="onSocialLinksChange($event)"
      />
    </div>
  }
</div>
